export interface IProfileDetails {
  avatar: string
  fName: string
  lName: string
  company: string
  contactPhone: string
  companySite: string
  country: string
  language: string
  timeZone: string
  currency: string
  communications: {
    email: boolean
    phone: boolean
  }
  allowMarketing: boolean
}

export interface IUpdateEmail {
  newEmail: string
  confirmPassword: string
}

export interface IUpdatePassword {
  currentPassword: string
  newPassword: string
  passwordConfirmation: string
}

export interface IConnectedAccounts {
  google: boolean
  github: boolean
  stack: boolean
}

export interface IEmailPreferences {
  successfulPayments: boolean
  payouts: boolean
  freeCollections: boolean
  customerPaymentDispute: boolean
  refundAlert: boolean
  invoicePayments: boolean
  webhookAPIEndpoints: boolean
}

export interface INotifications {
  notifications: {
    email: boolean
    phone: boolean
  }
  billingUpdates: {
    email: boolean
    phone: boolean
  }
  newTeamMembers: {
    email: boolean
    phone: boolean
  }
  completeProjects: {
    email: boolean
    phone: boolean
  }
  newsletters: {
    email: boolean
    phone: boolean
  }
}

export interface IDeactivateAccount {
  confirm: boolean
}

export const profileDetailsInitValues: IProfileDetails = {
  avatar: '/media/avatars/300-1.jpg',
  fName: 'Max',
  lName: 'Smith',
  company: 'Keenthemes',
  contactPhone: '044 3276 454 935',
  companySite: 'keenthemes.com',
  country: '',
  language: '',
  timeZone: '',
  currency: '',
  communications: {
    email: false,
    phone: false,
  },
  allowMarketing: false,
}

export const updateEmail: IUpdateEmail = {
  newEmail: 'support@keenthemes.com',
  confirmPassword: '',
}

export const updatePassword: IUpdatePassword = {
  currentPassword: '',
  newPassword: '',
  passwordConfirmation: '',
}


export const connectedAccounts: IConnectedAccounts = {
  google: true,
  github: true,
  stack: false,
}

export const emailPreferences: IEmailPreferences = {
  successfulPayments: false,
  payouts: true,
  freeCollections: false,
  customerPaymentDispute: true,
  refundAlert: false,
  invoicePayments: true,
  webhookAPIEndpoints: false,
}

export const notifications: INotifications = {
  notifications: {
    email: true,
    phone: true,
  },
  billingUpdates: {
    email: true,
    phone: true,
  },
  newTeamMembers: {
    email: true,
    phone: false,
  },
  completeProjects: {
    email: false,
    phone: true,
  },
  newsletters: {
    email: false,
    phone: false,
  },
}

export const deactivateAccount: IDeactivateAccount = {
  confirm: false,
}
export interface AddRolesInterface  {
  name: string
  status: number
  permissions: string[]
};
export interface RoleListInterface{
  id: number
  name: string | undefined
  status: number | undefined
  updated_by_name: string
  updated_at: string
  created_at: string
};
export interface UsersApplicationsListInterface{
  id: number
  application_name: string | undefined
  organization_name: string | undefined
  is_active: number | undefined
  status: number | undefined
  updated_by_name: string
  updated_at: string
  created_at: string
};
export interface PermissionsInterface {
  permission_key: string
  title: string
  create: string
  view: string
  update: string
  delete: string
  log?: string
  guard_name: string
};
export interface EditRoleInterface extends PermissionsInterface {
  id: number
  name: string
  status: number
  permissions: string[]
};
export interface AddAdminInterface  {
  first_name: string
  profile_picture:string
  role:string
  last_name: string
  email: string
};
export const addAdminInitValues: AddAdminInterface = {
  first_name: '',
  profile_picture:"",
  role: '',
  last_name: '',
  email: ''
};
export interface AdminListInterface{
  full_name: string
  id: number
  first_name: string
  last_name: string
  status:number
  middle_name:string
  profile_picture: string | undefined 
  role: string
  mobile_no:number
  email: string
  created_at: string
  update_by_admin_name: string
  updated_at: string
};
// User Module Interfaces
export interface AddUserInterface  {
  title: string
  name: string
  profile_picture: string
  role: string
  email: string
  status: string
};
export const addUserInitValues: AddUserInterface = {
  title: '',
  name: '',
  profile_picture: "",
  role: '',
  email: '',
  status: '1'
};
export interface UserListInterface{
  id: number
  title: string
  name: string
  email: string
  role: string
  role_id?: number
  profile_picture: string | undefined 
  status: number
  created_at: string
  updated_at: string
  updated_by_name?: string
};
export interface AddApplicationInterface {
  name: string
  server_url:string;
  frontend_domain_prefix:string;
  api_domain_prefix:string;
  api_url: string
  website_url: string
  logo: string
  description: string
  status: number
}

export const addApplicationInitialValues: AddApplicationInterface = {
  name: '',
  frontend_domain_prefix:'',
  api_domain_prefix:'',
  api_url: '',
  server_url:'',
  website_url: '',
  logo: '',
  description: '',
  status: 1,
}
export interface ApplicationsListInterface {
  id: number
  name: string
  server_url:string
  api_domain_prefix:string
  frontend_domain_prefix:string
  api_url: string
  website_url: string
  white_logo: string | undefined
  colored_logo:string | undefined
  favicon :string | undefined
  preloader:string | undefined
  description: string
  created_at: string
  updated_at: string
  status: number
}